module.exports = "/images/logo-markless.svg?b7ca96be4ce75913ea5d11507ce933f8";